module.exports = __webpack_public_path__ + "img/GF.55df0a2e.svg";